import React from 'react';
import MakeAnotherOfferAction from "./MakeAnotherOfferAction";

export default function MakeAnotherOfferAction1(props) {
    return (
        <MakeAnotherOfferAction  request={props.request} onActionComplete={props.onActionComplete}/>
    );
}